import { useRepositories } from '../../../infrastructure/http/RepositoryProvider';
import { useAdminList } from './useAdminList';

// Todos los lotes, para ayudar a un cliente. Se buscan por nombre, cultivo o
// dueño, de a una página (calcular el estado de cada uno no es gratis).
export function useAdminLots() {
  const { admin } = useRepositories();
  return useAdminList((params) => admin.fetchLots(params).then((r) => ({ items: r.lots, total: r.total })));
}
